"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _string = require("../type-checks/string");
var _react = require("react");
/**
 * Hook to expose current breakpoint by key and value on resize events
 *
 * @name useContentService
 * @param {object} Configuration object with statusTextError (default "error"), statusTextLoaded (default "loaded"), statusTextLoading (default "loading"), and url (required string)
 * @returns {Promise<object>} XHTTP request object returning content fragment
 */
const useContentService = _ref => {
  let {
    statusTextError = "error",
    statusTextLoaded = "loaded",
    statusTextLoading = "loading",
    url
  } = _ref;
  const [result, setResult] = (0, _react.useState)({
    status: statusTextLoading
  });
  (0, _react.useEffect)(() => {
    if ((0, _string.isStringOfLength)(url)) {
      fetch(url).then(response => response.text()).then(response => setResult({
        status: statusTextLoaded,
        payload: response
      })).catch(error => setResult({
        status: statusTextError,
        error
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return result;
};
var _default = exports.default = useContentService;